import { Translate } from '@above-the-treeline/localization';

export const RegistrationFormItems = {
	GetNameItem: (nameType: string) => {
		return {
			label: <Translate id={`${nameType}_name`} />,
			fieldDecorator: `${nameType}Name`,
			rules: [
				{
					required: true,
					message: (
						<Translate id={`please_enter_your_${nameType}_name`} />
					),
					whitespace: true,
				},
			],
		};
	},
	Email: {
		label: <Translate id="email_address" />,
		fieldDecorator: 'email',
		rules: [
			{
				type: 'email',
				message: (
					<Translate id="please_provide_a_valid_email_address" />
				),
			},
			{
				required: true,
				message: <Translate id="please_provide_your_email_address" />,
			},
		],
	},
	Password: {
		label: <Translate id="password" />,
		fieldDecorator: 'pword',
		rules: [
			{
				required: true,
				message: <Translate id="please_provide_a_password" />,
				whitespace: true,
			},
		],
	},
	ConfirmPassword: {
		label: <Translate id="confirm_password" />,
		dependencies: ['pword'],
		fieldDecorator: 'confirm_pword',
		rules: [
			{
				required: true,
				message: <Translate id="please_confirm_your_password" />,
				whitespace: true,
			},
		],
	},
	CurrentPassword: {
		label: <Translate id="current_password" />,
		fieldDecorator: 'current_pword',
		rules: [
			{
				required: true,
				message: <Translate id="please_input_your_current_password" />,
				whitespace: true,
			},
		],
	},
	Country: {
		label: <Translate id="country" />,
		fieldDecorator: 'country_code',
		fieldType: 'select',
		rules: [{ required: false }],
	},
	KeepMeUpdated: {
		label: <Translate id="registration_keep_me_updated" />,
		fieldDecorator: 'do_keep_me_updated',
		fieldType: 'checkbox',
		rules: [{ required: false }],
	},
};
